module.exports = __webpack_public_path__ + "static/media/banner3.10d57377.jpg";